import { sendRequest, HttpMethods } from "../util/ApiHelper";

const CONTROLLER_NAME = "PurchaseOrders";

export interface GetPurchaseOrderTermsData {
  poNumber: string;
}

export const getPurchaseOrderTermsData = async (
  params: GetPurchaseOrderTermsData
) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetPurchaseOrderTermsData`,
    {},
    params
  );
};

type CheckDuplicateBOLParams = {
  billOfLading: string;
  supplier: string;
  comments: string;
};

export const checkDuplicateBOL = async (params: CheckDuplicateBOLParams) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/CheckDuplicateBOL`,
    {},
    params
  );
};

export const getPOLiteList = async (data: any) => {
  return await sendRequest(
    HttpMethods.POST,
    `${CONTROLLER_NAME}/GetLiteList`,
    data
  );
};

export const findPO = async (searchTerm: string) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/Find`,
    undefined,
    {
      searchTerm: searchTerm,
    }
  );
};
